import Minors from './Minors';

export default Minors;
